import {
  type RadioGroupProps as MantineRadioGroupProps,
  Radio,
} from "@mantine/core";
import { type ChangeEvent, type ForwardedRef, forwardRef } from "react";
import type { FieldValues, Path, PathValue } from "react-hook-form";

export type RadioGroupProps = MantineRadioGroupProps;
type Props<FORM_TYPE extends FieldValues> = {
  onChange?:
    | ((value: string[]) => void)
    | ((
        event: ChangeEvent<Element> | PathValue<FORM_TYPE, Path<FORM_TYPE>>,
      ) => void);
  value?: string;
  children: React.ReactNode;
} & Omit<RadioGroupProps, "children" | "onChange">;

export const RadioGroup = forwardRef(function RadioGroup<
  FORM_TYPE extends FieldValues,
>(props: Props<FORM_TYPE>, ref: ForwardedRef<HTMLInputElement>) {
  const { children, ...radioProps } = props;
  const defaultOption: Omit<RadioGroupProps, "children"> = {};
  const option = Object.assign({}, defaultOption, radioProps);
  return (
    <Radio.Group {...option} ref={ref}>
      {children}
    </Radio.Group>
  );
});
